import { Component, Prop, Vue } from 'vue-property-decorator'

import { library } from '@fortawesome/fontawesome-svg-core'

import { cloneDeep } from 'lodash'
import InputPortal from '@/components/edit/InputPortal/index.vue'
import Loader from '@/components/Loader/index.vue'

import api from '@/helpers/fetch'

import { faTrashAlt, faCheck } from '@fortawesome/free-solid-svg-icons'
import Control from '@/helpers/control'

library.add(faTrashAlt, faCheck)

interface Item {
	label: string
}

@Component({
	components: {
		InputPortal,
		Loader,
	},
})
export default class ManageArray extends Vue {
	@Prop() readonly array!: []
	@Prop({ default: null }) readonly options!: [any]
	@Prop({ default: 'fulano@empresa.com.br' }) readonly placeholder!: string

	dynamicArray: any[] = []
	key = 0
	deleteKey = 0
	keyObject = 0
	loading = false
	success = false
	first = false

	control = new Control()

	async created() {
		if (!Array.isArray(this.array)) {
			console.error('Array prop is not a valid array')
		} else {
			if (this.array.length === 0) {
				this.first = true
			}
			this.dynamicArray = cloneDeep(this.array)
		}
	}

	preventToggleSecondaryNumber = {}
	async toggleSecondaryNumberState(item) {
		this.setLoading(true)
		const found = this.dynamicArray.find(sec => {
			if (sec.active && sec.id !== item.id) {
				return true
			}

			return false
		})

		if (!found) {
			item.active = !item.active

			const payload = {
				id: item.id,
				active: item.active
			}

			const res = await api.put('/api/secondary-numbers/updateState', payload)

			if (res.ok) {
				this.setSuccess(true)
			}
		} else {
			Vue.set(this.preventToggleSecondaryNumber, item.id, true)
		}
		this.setLoading(false)
	}

	mouseout(id) {
		Vue.set(this.preventToggleSecondaryNumber, id, false)
	}

	itemRemove(item, index: number) {
		if (this.dynamicArray) {
			this.dynamicArray.splice(index, 1)
			this.rerender('delete')
			this.onUpdate()
		}
	}

	itemAdd() {
		if (!this.dynamicArray) {
			this.dynamicArray = []
		}

		if (this.dynamicArray) {
			if (this.dynamicArray.length === 0) {
				this.first = false
			}
			this.dynamicArray.push({ number: '', type: '' })
			this.rerender()
		}
	}

	rerender(type?) {
		if (type === 'delete') this.deleteKey++
		else this.key++
	}

	rerenderOnlyFirst() {
		return this.first
	}

	onInput(field, $event, index) {
		const newValue = $event

		if (this.dynamicArray) {
			const item = this.dynamicArray[index]

			item[field] = newValue

			this.dynamicArray.splice(index, 1, item)
			this.keyObject++

			const debouncedChange = this.control.debounce(this.onUpdate, 1000)
			debouncedChange()
		}
	}

	onUpdate() {
		this.setLoading(true)
		this.$emit('onUpdate', this.dynamicArray)
	}

	setLoading(value) {
		this.loading = value
		this.rerender()
	}

	setSuccess(value) {
		this.success = value
		this.rerender()
	}
}
